/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import api from "_config/api";

export type PostOuvidoriaInformativo = {
  id: string;
  titulo: string;
  descricao: string;
  endereco: {
    tipoLogradouro: string;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    municipio: string;
    uf: string;
    cep: string;
  };
};

export interface GetInformativesGeojsonRequest {
  search?: string;
  onSuccess?: (data: PostOuvidoriaInformativo) => void;
}

interface State {
  isRequesting: boolean;
  successPayload: GeoJSON.FeatureCollection<
    GeoJSON.Point,
    PostOuvidoriaInformativo
  > | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const getInformativesGeojsonSlice = createSlice({
  name: "ouvidoria.informativo@getInformativesGeojson",
  initialState,
  reducers: {
    getInformativesGeojsonRequest: (
      state,
      _action: PayloadAction<GetInformativesGeojsonRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    getInformativesGeojsonSuccess: (
      state,
      action: PayloadAction<
        GeoJSON.FeatureCollection<GeoJSON.Point, PostOuvidoriaInformativo>
      >
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getInformativesGeojsonFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: GetInformativesGeojsonRequest;
}) {
  try {
    const { onSuccess, search } = params.payload;

    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      "api/v1/cidadao/ouvidoria/informativos/geojson",
      {
        params: {
          search
        }
      }
    );

    if (onSuccess) onSuccess(response.data);

    yield put(getInformativesGeojsonSuccess(response.data));
  } catch (error) {
    yield put(getInformativesGeojsonFailed([]));
  }
}

export const {
  getInformativesGeojsonFailed,
  getInformativesGeojsonRequest,
  getInformativesGeojsonSuccess
} = getInformativesGeojsonSlice.actions;

export const { reducer } = getInformativesGeojsonSlice;
export const saga = takeLatest(
  getInformativesGeojsonRequest.type,
  sagaFunction
);
